import { Urls } from "src/common/urls"

export const redirectToLogout = () => {
    window.location.href = Urls.FRONTEND.LOGOUT
}